<template>
  <base-section
    id="contact-us"
    space="56"
  >
    <v-container
      v-intersect.quiet="{
        handler: onIntersect,
        options: {
          threshold: [0.5]
        }
      }"
    >
      <v-row justify="space-between">
        <v-col
          cols="12"
          md="5"
        >
          <base-business-info title="KEEP IN TOUCH WITH US" />
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <base-contact-form title="MAIL US YOUR MESSAGE" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import { eventBus } from '../../main'

  export default {
    name: 'SectionContactUs',

    methods: {
      onIntersect (entries, observer) {
        if (entries[0].intersectionRatio >= 0.5) {
          eventBus.$emit('selectTab', 'contact')
        }
      },
    },
  }
</script>
